import script from "./ListadoArchivos.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoArchivos.vue?vue&type=script&setup=true&lang=js"

import "./ListadoArchivos.vue?vue&type=style&index=0&id=05309186&scoped=true&lang=css"

import exportComponent from "/var/www/html/manual/expositores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05309186"]])

export default __exports__